export var addEventListener = function (ref, name, cb, options) {
    if (cb) {
        ref.addEventListener(name, cb, options);
    }
};
export var removeEventListener = function (ref, name, cb, options) {
    if (cb) {
        ref.removeEventListener(name, cb, options);
    }
};
